import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductIsbn extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateIsbn);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateIsbn);
  }

  /**
   * Updates the ISBN when the selected variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateIsbn = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newIsbn = event.detail.data.html.querySelector('product-isbn');

    if (!newIsbn) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    morph(this, newIsbn, { childrenOnly: true });
  };
}

if (!customElements.get('product-isbn')) {
  customElements.define('product-isbn', ProductIsbn);
}
